import { render, staticRenderFns } from "./landZhenPropertyAdd.vue?vue&type=template&id=4331c437"
import script from "./landZhenPropertyAdd.vue?vue&type=script&lang=js"
export * from "./landZhenPropertyAdd.vue?vue&type=script&lang=js"
import style0 from "./landZhenPropertyAdd.vue?vue&type=style&index=0&id=4331c437&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports